export default {
  install(Vue, { env }) {
    Vue.prototype.$microservicesUrls = Vue.microservicesUrls = {
      hulk: env.VUE_APP_MICROSERVICES_SALES_HTTP || 'https://hulk.mercafacil.com/graphql',
    }
  },
}
